// DashboardLayout.jsx
import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./core/Sidebar";
import Header from "./core/Header";
import OperatorPage from "../components/CustomTable/OperatorPage"; // Import the OperatorPage component

const DashboardLayout = ({ handleAnalytics }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [activePage, setActivePage] = useState(""); // State to track the active content

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  // Function to show the operator page content
  const showOperatorPage = () => {
    setActivePage("operator");
  };

  return (
    <div sx={{ display: "flex", height: "100vh" }}>
      {/* Pass the function to Sidebar to trigger the operator page */}
      <Sidebar
        handleAnalytics={handleAnalytics}
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        onOperatorClick={showOperatorPage} // Handle operator click to show data
      />
      <Box
        sx={{
          flexGrow: 1,
          transition: "margin 0.3s ease",
          marginLeft: isSidebarOpen ? "240px" : "60px",
          overflowX: "hidden",
        }}
      >
        <Header toggleSidebar={toggleSidebar} />
        <Box>
          {/* Conditionally render the operator page or outlet content */}
          {activePage === "operator" ? (
            <OperatorPage /> // Render the operator data page
          ) : (
            <Outlet /> // Render the default content (other pages)
          )}
        </Box>
      </Box>
    </div>
  );
};

export default DashboardLayout;
